module.exports = __webpack_public_path__ + "img/form-docs-circle.9f139a7e.svg";